import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { CommissionIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createOlCommission } from '../../api/ols/commissions/create-ol-commission'
import UserNavBar from '../../components/elements/nav-bar'
import OlCommissionForm from '../../components/pages/ols/ol-commissions/ol-commission-form'
import { Paths } from '../../lib/constants/path'
import { CurrencyEnum } from '../../lib/types/enums/common/currency.enum'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const OlCommissionCreatePage = () => {
  const { back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createOlCommission,
    onError: showAxiosError,
    onSuccess: () => toast.success('Fees créée avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Ajouter une nouvelle fees / avance / retainer'} icon={CommissionIcon} />
      <div className={'h-4'} />
      <Box>
        <OlCommissionForm
          mode="normal"
          title={'Fees'}
          defaultValues={{
            currency: CurrencyEnum.EUR
          }}
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              await mutateAsync(values)
              back(Paths.OL_COMMISSIONS_LIST_PAGE)
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default OlCommissionCreatePage
